import Cookies from 'js-cookie'

const TokenKey = 'accessToken'

export function getToken() {
  if(process.env.NODE_ENV==='dev'){
    return Cookies.get(TokenKey)
  }else{
    return Cookies.get(TokenKey,{'domain':process.env.INDEX_HOST})
  }
}

export function setToken(token) {
  if(process.env.NODE_ENV==='dev'){
    return Cookies.set(TokenKey, token)
  }else{
    return Cookies.set(TokenKey, token,{'domain':process.env.INDEX_HOST})
  }
}

export function removeToken() {
  if(process.env.NODE_ENV==='dev'){
    return Cookies.remove(TokenKey)
  }else{
    return Cookies.remove(TokenKey,{'domain':process.env.INDEX_HOST})
  }
}




// WEBPACK FOOTER //
// ./src/utils/auth.js